// extracted by mini-css-extract-plugin
export default {"base":"submit-button_base__qqXIG"};